import React, { Component, useState, useRef } from 'react';
import './FormPart.css';
import InputMask from 'react-input-mask';
import axios from 'axios';

function FormPart() {

    const [campos, setFormData] = useState({
        nomeProjeto : '',
        numeroProjeto : '',
        valorTotAprovCap : '',
        leiIncentivo : '',
        conseguiuCaptar : '',
        oferecidoComunidade : '',
        faixaEtaria : '',
        nomeProponente : '',
        cpf : '',
        email : '',
        telefone : '',
        tipoPessoa : '',
        razaoSocial : '',
        cnpj : '',
        endereco : '',
        dadosPessoaJuridica : '',
        ecolabCooperado : '',
        ecolabCoopParentesco : '',
        eFuncPub : '',
        conflitoInteresse : '',
        nomeRespPreench : '',
        cpfRespPreench : '',
        deuAceiteConfInter : '',
        deuAceiteTermos : '',
        docPubAprov : '',
        docApresProj : '',
        docHistReali : ''
      });

      const fileInputRef = useRef(null);
      const fileInputRef1 = useRef(null);
      const fileInputRef2 = useRef(null);

      const [docPubAprov, setnomePdf1] = useState(null);
      const [docApresProj, setnomePdf2] = useState(null);
      const [docHistReali, setnomePdf3] = useState(null);

      const [isLoading, setIsLoading] = useState(false);
      const [isSucesso, setIsSucesso] = useState(false);
      const [isErro, setisErro] = useState(false);

      const handleInputChange = (e) => {
        setFormData({
          ...campos,
          [e.target.name]: e.target.value,
        });
      };


      const handleButtonClick1 = () => {
        fileInputRef.current.click();
      };

      const handleButtonClick2 = () => {
        fileInputRef1.current.click();
      };

      const handleButtonClick3 = () => {
        fileInputRef2.current.click();
      };
    
      const handleFileChange = (e) => {
        const fieldName = e.target.name;
        const file = e.target.files[0];
      
        // Atualizar o estado local com o nome do arquivo
        if (fieldName === "docPubAprov") {            
            setnomePdf1(file);
        } else if (fieldName === "docApresProj") {            
            setnomePdf2(file);
        } else if (fieldName === "docHistReali") {
            setnomePdf3(file);
        }
      
        // Atualizar o estado local dos campos do formulário
        const updatedFormData = { ...campos };
      
        if (fieldName === "docPubAprov") {
          updatedFormData.docPubAprov = file;
        } else if (fieldName === "docApresProj") {
          updatedFormData.docApresProj = file;
        } else if (fieldName === "docHistReali") {
          updatedFormData.docHistReali = file;
        }
      
        setFormData(updatedFormData);

      };
    

        const handleSubmit = async (e) => {
        e.preventDefault();  
        setIsLoading(true);
        setIsSucesso(false);
        setisErro(false);

        try {

            const formData = new FormData();
            Object.keys(campos).forEach(key => {
                // Pular campos de arquivo que serão tratados separadamente
                if (key !== 'docPubAprov' && key !== 'docApresProj' && key !== 'docHistReali') {
                    formData.append(key, campos[key]);
                }
            });

            // Adicionar apenas os arquivos selecionados ao FormData
            if (docPubAprov) formData.append('docPubAprov', docPubAprov);
            if (docApresProj) formData.append('docApresProj', docApresProj);
            if (docHistReali) formData.append('docHistReali', docHistReali);

            const response = await axios.post(
                process.env.REACT_APP_API_FORM_PATROCINIO,
                formData
            );

            setIsLoading(false);
            
            if(response.data.status === "sucesso"){

                setIsSucesso(true);
                setisErro(false);

                e.target.reset();

                setFormData({
                    nomeProjeto : "",
                    numeroProjeto : '',
                    valorTotAprovCap : '',
                    leiIncentivo : '',
                    conseguiuCaptar : '',
                    oferecidoComunidade : '',
                    faixaEtaria : '',
                    nomeProponente : '',
                    cpf : '',
                    email : '',
                    telefone : '',
                    tipoPessoa : '',
                    razaoSocial : '',
                    cnpj : '',
                    endereco : '',
                    dadosPessoaJuridica : '',
                    ecolabCooperado : '',
                    ecolabCoopParentesco : '',
                    eFuncPub : '',
                    conflitoInteresse : '',
                    nomeRespPreench : '',
                    cpfRespPreench : '',
                    deuAceiteConfInter : '',
                    deuAceiteTermos : '',
                    docPubAprov : '',
                    docApresProj : '',
                    docHistReali : ''
                });

                setnomePdf1(null);
                setnomePdf2(null);
                setnomePdf3(null);

                setTipoPessoa("Física");

            }else{

                setIsSucesso(false);
                setisErro(true);

            } 

        } catch (error) {
          console.error('Erro ao enviar o formulário:', error);
          setIsLoading(false);
          setisErro(true);
        }
      };

      const [tipoPessoa, setTipoPessoa] = useState("Física");

      const handleInputChangeTwo = (event) => {
        setTipoPessoa(event.target.value);
        // Também atualizar o estado campos para incluir no formData
        setFormData({
            ...campos,
            tipoPessoa: event.target.value,
        });
    };

    return (
        <div className="container text-center">
            <form className="my-form" onSubmit={handleSubmit}>

                <h2>Inscrição do Projeto</h2>
                <br />
                <div class="mb-3">
                    <label for="nomeProjeto" class="form-label">Nome do projeto:</label>
                    <input type="text" class="form-control" id="nomeProjeto" name="nomeProjeto" minlength="8" value={campos.nomeProjeto} onChange={handleInputChange} required />
                </div>
                <div class="mb-3">
                    <label for="numeroProjeto" class="form-label">Número do projeto (PRONAC/CA):</label>
                    <input type="text" class="form-control" id="numeroProjeto" name="numeroProjeto" value={campos.numeroProjeto} onChange={handleInputChange} required />
                </div>
                <div class="mb-3">
                    <label for="valorAprovado" class="form-label">Valor total aprovado para a captação (R$):</label>
                    <input type="text" class="form-control" id="valorTotAprovCap" name="valorTotAprovCap" value={campos.valorTotAprovCap} onChange={handleInputChange} required />
                </div>
                <div class="mb-3">
                    <label for="tipoLeiIncentivo" class="form-label">Selecione a lei de incentivo:</label>
                    <select class="form-select" id="tipoLeiIncentivo" name="leiIncentivo" value={campos.leiIncentivo} onChange={handleInputChange} required>
                        <option value="">Selecione</option>
                        <option value="Lei 1">Lei Federal de incentivo à cultura – Rouanet</option>
                        <option value="Lei 2">Lei Federal de incentivo ao esporte</option>
                        <option value="Lei 3">PRONON</option>
                        <option value="Lei 4">PRONAS</option>
                        <option value="Lei 5">FIA – Fundo para a Infância e Adolescência</option>
                        <option value="Lei 6">FNI – Fundo Nacional do Idoso</option>
                        <option value="Lei 7">PMIC – Lei Municipal de Incentivo à Cultura de Uberlândia</option>

                    </select>
                </div>
                <div class="mb-3">
                    <label for="captacaoRecurso" class="form-label">O projeto já conseguiu captar algum recurso?</label>
                    <div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="conseguiuCaptar" id="conseguiuCaptar" 
                                checked={campos.conseguiuCaptar === "Sim"} onChange={handleInputChange} value="Sim" />
                            <label class="form-check-label" for="captacaoRecursoSim">Sim</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="conseguiuCaptar" id="conseguiuCaptar" 
                                checked={campos.conseguiuCaptar === "Não"} onChange={handleInputChange} value="Não" />
                            <label class="form-check-label" for="captacaoRecursoNao">Não</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="gratuitoComunidade" class="form-label">O projeto é oferecido para a comunidade de forma totalmente gratuita?</label>
                    <div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="oferecidoComunidade" 
                                checked={campos.oferecidoComunidade === "Sim"}  onChange={handleInputChange} id="oferecidoComunidade" value="Sim" />
                            <label class="form-check-label" for="gratuitoComunidadeSim">Sim</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="oferecidoComunidade" 
                                checked={campos.oferecidoComunidade === "Não"} onChange={handleInputChange} id="oferecidoComunidade" value="Não" />
                            <label class="form-check-label" for="gratuitoComunidadeNao">Não</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="faixaEtaria" class="form-label">Faixa etária dos participantes:</label>
                    <div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "0 - 5 anos"} id="0_5_anos" value="0 - 5 anos" onChange={handleInputChange}/>
                            <label class="form-check-label" for="0_5_anos">0 - 5 anos</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "6 - 14 anos"} id="6_14_anos" value="6 - 14 anos" onChange={handleInputChange}/>
                            <label class="form-check-label" for="6_14_anos">6 - 14 anos</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "15 - 18 anos"} id="15_18_anos" value="15 - 18 anos" onChange={handleInputChange}/>
                            <label class="form-check-label" for="15_18_anos">15 - 18 anos</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "19 - 39 anos"} id="19_39_anos" value="19 - 39 anos" onChange={handleInputChange}/>
                            <label class="form-check-label" for="19_39_anos">19 - 39 anos</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "40 - 59 anos"} id="40_59_anos" value="40 - 59 anos" onChange={handleInputChange}/>
                            <label class="form-check-label" for="40_59_anos">40 - 59 anos</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "60 - 79 anos"} id="60_79_anos" value="60 - 79 anos" onChange={handleInputChange}/>
                            <label class="form-check-label" for="60_79_anos">60 - 79 anos</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="faixaEtaria" 
                                checked={campos.faixaEtaria === "Acima de 80"} id="acima_80_anos" value="Acima de 80" onChange={handleInputChange}/>
                            <label class="form-check-label" for="acima_80_anos">Acima de 80</label>
                        </div>
                    </div>
                </div>


                <h2>Dados do(a) proponente</h2>
                <div class="mb-3">
                    <label for="nomeProponente" class="form-label">Nome do proponente:</label>
                    <input type="text" class="form-control" id="nomeProponente" name="nomeProponente" 
                        value={campos.nomeProponente} onChange={handleInputChange} required />
                </div>
                <div class="mb-3">
                    <label for="emailProponente" class="form-label">E-mail do proponente:</label>
                    <input type="email" class="form-control" id="emailProponente" name="email" 
                        value={campos.email} onChange={handleInputChange} required />
                </div>
                <div class="mb-3">
                    <label for="cpfProponente" class="form-label">CPF do proponente:</label>
                    <InputMask type="text" class="form-control" id="cpfProponente" name="cpf" 
                        value={campos.cpf} mask="999.999.999-99" onChange={handleInputChange} required />
                </div>
                <div class="mb-3">
                    <label for="telefoneProponente" class="form-label">Telefone do proponente:</label>
                    <InputMask type="tel" class="form-control" id="telefoneProponente" name="telefone" 
                        value={campos.telefone} mask="(99) 99999-9999" onChange={handleInputChange} required />
                </div>
                <div className="mb-3">
                <label htmlFor="tipoProponente" className="form-label">O projeto foi inscrito em nome da pessoa física ou jurídica?</label>
                <br />
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoPessoa"
                        id="tipoProponenteFisica"
                        value="Física"
                        checked={tipoPessoa === "Física"}
                        onChange={handleInputChangeTwo}
                    />
                    <label className="form-check-label" htmlFor="tipoProponenteFisica">Pessoa Física</label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoPessoa"
                        id="tipoProponenteJuridica"
                        value="Jurídica"
                        checked={tipoPessoa === "Jurídica"}
                        onChange={handleInputChangeTwo}
                    />
                    <label className="form-check-label" htmlFor="tipoProponenteJuridica">Pessoa Jurídica</label>
                </div>
            </div>
            <br />
            {tipoPessoa === "Jurídica" && (
                <div>
                    <div className="mb-3">
                        <label htmlFor="razaoSocial" className="form-label" style={{ color: '#979797' }}>Razão Social:</label>
                        <input type="text" className="form-control" id="razaoSocial" name="razaoSocial" value={campos.razaoSocial} onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="cnpj" className="form-label" style={{ color: '#979797' }}>CNPJ:</label>
                        <InputMask
                            type="text"
                            className="form-control"
                            id="cnpj"
                            name="cnpj"
                            value={campos.cnpj}
                            mask="99.999.999/9999-99"
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="endereco" className="form-label" style={{ color: '#979797' }}>Endereço completo (Rua/Av./Praça, número, bairro, CEP):</label>
                        <textarea className="form-control" id="endereco" name="endereco" rows="3" value={campos.endereco} onChange={handleInputChange}></textarea>
                    </div>
                </div>
            )}
                <div class="mb-3">
                    <label class="form-label" style={{ color: '#979797' }}>Os dados do representante legal da pessoa jurídica são os mesmos que já foram informados nesse formulário?</label>
                    <div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="dadosPessoaJuridica" id="mesmoRepresentanteSim" 
                                checked={campos.dadosPessoaJuridica === "Sim"} value="Sim" onChange={handleInputChange} />
                            <label class="form-check-label" for="mesmoRepresentanteSim">Sim</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="dadosPessoaJuridica" id="mesmoRepresentanteNao" 
                                checked={campos.dadosPessoaJuridica === "Não"} value="Não" onChange={handleInputChange} />
                            <label class="form-check-label" for="mesmoRepresentanteNao">Não</label>
                        </div>
                    </div>
                </div>


                <h2>Documentos do Projeto</h2>
                <br />
                <div class="mb-3">
                    <label for="publicacaoAprovacao" class="form-label">Publicação de aprovação ou prorrogação dos projetos no diário oficial:</label>
                    <div class="input-group">
                        <input type="file" id="docPubAprov" name="docPubAprov" ref={fileInputRef} key={docPubAprov} style={{ display: 'none' }} onChange={handleFileChange}/>
                        <button type="button" class="btn btn-primary" id="anexar" onClick={handleButtonClick1}>Anexo</button>
                        <span class="m-2">{docPubAprov?.name}</span>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="apresentacaoProjeto" class="form-label">Apresentação do projeto, incluindo as suas contrapartidas sociais:</label>
                    <div class="input-group">
                        <input type="file" id="docApresProj" name="docApresProj" ref={fileInputRef1} key={docApresProj} style={{ display: 'none' }} onChange={handleFileChange} />
                        <button type="button" class="btn btn-primary" id="anexar"  onClick={handleButtonClick2} >Anexo</button>
                        <span class="m-2">{docApresProj?.name}</span>
                    </div>
                </div>

                <div class="mb-3">
                    <label for="historicoProjetos" class="form-label">Histórico de projetos realizados:</label>
                    <div class="input-group">
                        <input type="file" id="docHistReali" name="docHistReali" ref={fileInputRef2} key={docHistReali} style={{ display: 'none' }} onChange={handleFileChange} />
                        <button type="button" class="btn btn-primary" id="anexar" onClick={handleButtonClick3}>Anexo</button>
                        <span class="m-2">{docHistReali?.name}</span>
                    </div>
                </div>



                <h2>Compliance</h2>
                <div class="mb-3">
                    <label class="form-label">O proponente ou algum dos terceiros listados em seu projeto é colaborador ou cooperado do grupo Unimed?</label>
                    <div>
                        <br />
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="ecolabCooperado" id="colaboradorUnimedSim" checked={campos.ecolabCooperado === "Sim"} onChange={handleInputChange} value="Sim" />
                            <label class="form-check-label" for="colaboradorUnimedSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="ecolabCooperado" id="colaboradorUnimedNao" checked={campos.ecolabCooperado === "Não"} onChange={handleInputChange} value="Não" />
                            <label class="form-check-label" for="colaboradorUnimedNao">Não</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">O proponente ou algum dos terceiros listados em seu projeto possuem relação de parentesco com algum colaborador ou cooperado do grupo Unimed?</label>
                    <div>
                        <br />
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="ecolabCoopParentesco" id="colaboradorUnimedParentescoSim" checked={campos.ecolabCoopParentesco === "Sim"} onChange={handleInputChange} value="Sim" />
                            <label class="form-check-label" for="colaboradorUnimedParentescoSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="ecolabCoopParentesco" id="colaboradorUnimedParentescoNao" checked={campos.ecolabCoopParentesco === "Não"} onChange={handleInputChange} value="Não" />
                            <label class="form-check-label" for="colaboradorUnimedParentescoNao">Não</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">O proponente ou algum dos terceiros listados em seu projeto é funcionário público, seja de esfera municipal, estadual ou federal?</label>
                    <div>
                        <br />
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="eFuncPub" id="colaboradorFuncPubUnimedSim" checked={campos.eFuncPub === "Sim"} onChange={handleInputChange} value="Sim" />
                            <label class="form-check-label" for="colaboradorFuncPubUnimedSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="eFuncPub" id="colaboradorFuncPubUnimedNao" checked={campos.eFuncPub === "Não"} onChange={handleInputChange} value="Não" />
                            <label class="form-check-label" for="colaboradorFuncPubUnimedNao">Não</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Considerando todas as pessoas envolvidas no seu projeto, você afirma que não há relações que gerem conflito de interesse?</label>
                    <p id='obs'>Por conflito de interesse entende-se: quando questões diversas (profissionais, financeiras, familiares, políticas ou pessoais) podem interferir no julgamento das pessoas ao exercerem suas ações dentro das organizações e projetos sociais, favorecendo ou facilitando qualquer etapa do processo em benefício próprio ou de alguém.</p>
                    <div>
                        <br />
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="conflitoInteresse" id="colaboradorUnimedSim" checked={campos.conflitoInteresse === "Sim"} onChange={handleInputChange} value="Sim" />
                            <label class="form-check-label" for="colaboradorUnimedSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="conflitoInteresse" id="colaboradorUnimedNao" checked={campos.conflitoInteresse === "Não"} onChange={handleInputChange} value="Não" />
                            <label class="form-check-label" for="colaboradorUnimedNao">Não</label>
                        </div>
                    </div>
                </div>


                <br />
                <h2>Declaração</h2>
                <br />
                <div class="mb-3">
                    <label for="responsavelPreenchimento" class="form-label">Nome do responsável pelo preenchimento deste formulário:</label>
                    <input type="text" class="form-control" id="responsavelPreenchimento" name="nomeRespPreench" value={campos.nomeRespPreench} required onChange={handleInputChange}/>
                </div>
                <div class="mb-3">
                    <label for="cpfResponsavelPreenchimento" class="form-label">CPF do responsável pelo preenchimento deste formulário:</label>
                    <InputMask type="text" class="form-control" id="cpfResponsavelPreenchimento" name="cpfRespPreench" value={campos.cpfRespPreench} mask="999.999.999-99" required onChange={handleInputChange}/>
                </div>
                <div class="mb-3">
                    <label class="form-label" id='declaro'>Declaro, para os devidos fins, que as informações fornecidas no Formulário de Conflito de Interesses são verdadeiras, condizentes com os fatos à época de seu preenchimento e não ocultaram quaisquer dados. Se em algum momento as informações prestadas deixarem de representar a realidade, concordo em comunicar as mudanças imediatamente ao grupo Unimed, por meio do e-mail contato@institutounimeduberlandia.coop.br</label>
                    <div>
                        <br />
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="deuAceiteConfInter" id="confInteresseSim" checked={campos.deuAceiteConfInter === "Sim"} value="Sim" onChange={handleInputChange}/>
                            <label class="form-check-label" for="colaboradorUnimedSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="deuAceiteConfInter" id="confInteresseNao" checked={campos.deuAceiteConfInter === "Não"} value="Não" onChange={handleInputChange}/>
                            <label class="form-check-label" for="colaboradorUnimedNao">Não</label>
                        </div>
                    </div>
                </div>
                <br />
                <div class="mb-3">
                    <label class="form-label">Com o objetivo de avaliar os projetos que serão patrocinados via leis de incentivo fiscal, os dados não serão compartilhados com terceiros e as informações coletadas serão armazenadas em nuvem da Microsoft e/ou pasta física. O acesso aos dados e informações fornecidos se limitará à área de Governança Corporativa e de Riscos/Compliance.
                        <br /><br />
                        Os dados e informações serão retidos por 12 meses, desde que não haja obrigatoriedade legal que determine extensão ao prazo de retenção. Após o prazo informado, os dados serão permanentemente eliminados dos bancos de dados e as cópias físicas serão descartadas de forma segura.
                        <br /><br />
                        Ao preencher o formulário declaro estar ciente e de acordo com os Termos de uso informados e com a <a href='https://www.unimeduberlandia.coop.br/portal/privacidadededados/'>Política de Privacidade da Unimed Uberlândia.</a></label>
                    <div>
                        <br />
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="deuAceiteTermos" id="aceiteSim" checked={campos.deuAceiteTermos === "Sim"} value="Sim" onChange={handleInputChange}/>
                            <label class="form-check-label" for="colaboradorUnimedSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="deuAceiteTermos" id="aceiteNao" checked={campos.deuAceiteTermos === "Não"} value="Não" onChange={handleInputChange}/>
                            <label class="form-check-label" for="colaboradorUnimedNao">Não</label>
                        </div>
                    </div>
                </div>


                <div className="mb-3 d-flex justify-content-center">
                    <button type="submit" className="btn btn-primary" id='enviar' disabled={isLoading}>{isLoading ? 'Enviando...' : 'Enviar Projeto'}</button>
                </div>

                <div className="mb-3 d-flex justify-content-center" >     
                    <div style={{ display: 'none' }}>               
                        <div class="spinner-border text-success" role="status"  >
                            <span class="sr-only"></span>
                        </div>&nbsp;&nbsp;Enviando...
                    </div>
                </div>


                {isLoading && <div className="loader">
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only"></span>
                    </div>&nbsp;&nbsp;Enviando...</div>
                }

                {isSucesso && 
                    <div className="mb-3 d-flex justify-content-center"  >
                        <alert class="alert alert-success" id="msgSuccesso">Mensagem enviada com sucesso.</alert>
                        
                    </div>
                }

                {isErro && 
                    <div className="mb-3 d-flex justify-content-center" >
                            <alert class="alert alert-danger" id="msgErro">Nenhum processamento realizado. Aguarde alguns minutos e tente novamente</alert>
                    </div>
                }

            </form>
        </div>
    );
};

export default FormPart;